import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const ErrorOutlineIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="alert-circle" {...props} />;
};

export { ErrorOutlineIcon };
